import { ModalBody } from 'core/components/common/ModalBody'
import { ModalHeader } from 'core/components/common/ModalHeader'
import ModalWrapper from 'core/components/common/ModalWrapper'
import React from 'react'
import { useTranslation } from 'react-i18next'

type DeleteExternalMcpModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export const DeleteExternalMcpModal: React.FC<DeleteExternalMcpModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation()

  const hide = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    onClose()
  }

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <ModalWrapper
      classNames={{ modal: 'modal modal-external-mcp-delete' }}
      onClose={onClose}
      open={open}
      showCloseIcon={false}
    >
      <ModalHeader titleClassName="modal-title mt-[20px]">
        {t('prompts.form.advanced.mcp.deleteModal.title')}
      </ModalHeader>
      <ModalBody className="mx-[30px] my-[20px]">
        <div className="flex flex-col gap-y-[10px]">
          <span>{t('prompts.form.advanced.mcp.deleteModal.text1')}</span>
          <span>{t('prompts.form.advanced.mcp.deleteModal.text2')}</span>
        </div>
        <div className="text-right mt-[30px] self-end flex flex-col md:flex-row md:justify-end gap-y-[10px]">
          <button
            type="button"
            className="small-btn cancel w-full md:w-auto"
            onClick={hide}
          >
            {t('global.form.button.cancel')}
          </button>
          <button
            type="button"
            className="small-btn default w-full md:w-auto md:ml-[20px]"
            onClick={handleConfirm}
          >
            {t('prompts.form.advanced.mcp.deleteModal.confirm')}
          </button>
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}
